<main id="content" role="main" class="main">

    <div class="content container">

        <nav aria-label="breadcrumb">
            <ol id="w0" class="breadcrumb">
                <li class="breadcrumb-item">
                    <a routerLink="/">{{'home'|translate}}</a>
                </li>
                <li class="breadcrumb-item">
                    <a routerLink="/Sections"
                       [queryParams]="{SectionId:SectionIdEnv}">
                        {{'e-service'|translate}}
                    </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                    {{sectionName}}
                </li>
            </ol>
        </nav>

        <!-- Search -->
        <div class="services-search mb-5">

            <div class="search-box">

                <i class="fas fa-search search-icon"></i>

                <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="searchText"
                    (input)="filterServices()"
                    placeholder="{{'searchService' | translate}}">

                <button
                    type="button"
                    class="clear-btn"
                    *ngIf="searchText"
                    (click)="clearSearch()">
                    ✕
                </button>

            </div>

        </div>

        <div class="row row-cols-md-4 mb-10">

            <!-- New Website Services -->
            <div class="col mb-3 mb-lg-5"
                 *ngFor="let item of filteredServices">

                <div class="card card-hover-shadow text-center h-100">

                    <div class="card-progress-wrap">
                        <div class="progress card-progress">
                            <div
                                class="progress-bar {{colorArr[index]}}"
                                role="progressbar"
                                style="width:100%">
                            </div>
                        </div>
                    </div>

                    <div class="card-body">

                        <div class="row align-items-center text-start mb-4">
                            <div class="col">
                                <span class="badge bg-soft-danger text-danger p-2"></span>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center mb-2">
                            <img class="avatar avatar-lg"
                                 [src]="imagesArr[index]"
                                 alt="">
                        </div>

                        <div class="mb-2 {{textColorArr[index]}}">
                            <h4>{{item.name}}</h4>
                        </div>

                    </div>

                    <div class="card-footer">

                        <button
                            class="btn btn-outline-dark"
                            (click)="apply(item)">
                            {{'applyForm'|translate}}
                        </button>

                    </div>

                </div>

            </div>

            <!-- Old Website Services -->

            <ng-container *ngIf="filteredServices2.length>0">

                <div class="col mb-3 mb-lg-5"
                     *ngFor="let item of filteredServices2">

                    <div class="card card-hover-shadow text-center h-100">

                        <div class="card-progress-wrap">
                            <div class="progress card-progress">
                                <div
                                    class="progress-bar {{colorArr[index]}}"
                                    role="progressbar"
                                    style="width:100%">
                                </div>
                            </div>
                        </div>

                        <div class="card-body">

                            <div class="row align-items-center text-start mb-4">
                                <div class="col">
                                    <span class="badge bg-soft-danger text-danger p-2"></span>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center mb-2">
                                <img class="avatar avatar-lg"
                                     [src]="imagesArr[index]"
                                     alt="">
                            </div>

                            <div class="mb-2 {{textColorArr[index]}}">
                                <h4>{{item.title}}</h4>
                            </div>

                        </div>

                        <div class="card-footer">

                            <button
                                class="btn btn-outline-dark"
                                (click)="openForm(item.id)">
                                {{'applyForm'|translate}}
                            </button>

                        </div>

                    </div>

                </div>

            </ng-container>

        </div>

        <!-- No Result -->

        <div
            class="text-center py-5"
            *ngIf="filteredServices.length==0 && filteredServices2.length==0">

            <i class="fas fa-search fa-3x text-muted mb-3"></i>

            <h4 class="text-muted">
                {{'noServicesFound' | translate}}
            </h4>

        </div>

    </div>

</main>